import { Link } from "react-router-dom";
import PlatformPrivacyPolicyContent from "../components/PlatformPrivacyPolicyContent";

export default function PlatformPrivacyPolicyPage() {
  return (
    <main className="mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-14">
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-stone-900">
        Politique de confidentialite - Plateforme Raguia
      </h1>
      <p className="mt-2 text-sm text-stone-500">
        Politique applicable au portail client et au chatbot.
      </p>

      <div className="mt-8 rounded-2xl border border-stone-200 bg-white p-5 sm:p-8 shadow-sm">
        <PlatformPrivacyPolicyContent />
      </div>

      <p className="mt-8">
        <Link to="/" className="text-sm font-medium text-[#A43032] hover:underline">
          ← Retour a l&apos;accueil
        </Link>
      </p>
    </main>
  );
}
